// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-21-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-21-2024
// ***********************************************************************
// <copyright file="_validation.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utility for initializing and managing form validation using 
//     Bootstrap's validation classes, ensuring that form submissions are validated client-side.
// </summary>
// ***********************************************************************

window.validation = window.validation || {};

/**
 * Initializes client-side validation for all forms with the class `needs-validation`.
 * This function sets up an event listener for the `submit` event on each form,
 * preventing submission if the form is invalid and applying Bootstrap's validation styles.
 *
 * @function initialize
 * @memberof window.validation
 */
window.validation.initialize = function () {
    const forms = document.querySelectorAll('.needs-validation');

    Array.prototype.slice.call(forms).forEach((form) => {
        form.addEventListener('submit', function (event) {
            if (!form.checkValidity()) {
                event.preventDefault();
                event.stopPropagation();
            }

            form.classList.add('was-validated');
        }, false);
    });
};